import * as React from "react";
import MenuList from "@mui/material/MenuList";
import Typography from "@mui/material/Typography";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import HmSubHeaderTitle from "../../unit/HmSubHeaderTitle";
import CustomMenuItemLink from "../../unit/CustomMenuItemLink";
import { Link, useListContext } from "react-admin";
import { Box } from "@mui/material";
import CustomSelect from "../../unit/forms/CustomSelect";
import { hmLightTheme } from "../../themes/hmTheme";
import formatTitleText from "../../unit/formatTitleText";

const AppMenuTitle = ({ ...props }) => {
  const type = props.type;
  const appCounts = props.count;
  return (
    <Box component="span" sx={{ width: "100%", textTransform: "capitalize" }}>
      {type}
      {/* <Chip
        label={appCounts}
        size="small"
        sx={{
          ml: 1,
          float: "right",
          fontFamily: hmLightTheme?.palette?.numberFontFamily,
        }}
      /> */}
    </Box>
  );
};

const AchPaymentsAside = ({ ...props }) => {
  const { filterValues } = useListContext();
  const selected = filterValues?.status;
  const [selectMenu, setSelectMenu] = React.useState("disbursement");
  const status = filterValues.status;
  const totalData = props.totalData;
  const estNow = new Date(
    new Date().toLocaleString("en-US", { timeZone: "America/New_York" })
  );
  estNow.setDate(estNow.getDate() - 1);
  let headerTitle = `ACH as of ${estNow.toISOString().split("T")[0]} EST`;
  let headerSubTitle = "";
  if (status?.includes("Today") || status?.includes("today")) {
    // headerSubTitle = `* Payment scheduled today can be cancelled by 3:00 pm EST`;
    // headerTitle += `           * Payment scheduled today can be cancelled by 3:00 pm EST`;
    headerSubTitle = `Cancel by 3PM EST`;
  }
  const loanMenus = [
    {
      id: "repayments",
      name: "Repayments",
      items: [
        {
          // id: "repayment_past45unableInitiate",
          // name: "Past 45 Days Unable to Initiate",
          id: "repayment_past30unableInitiate",
          name: "Past 30 Days Unable to Initiate",
        },
        {
          // id: "repayment_past45initiatedButFailed",
          // name: "Past 45 Days Initiated but Failed",
          id: "repayment_past30initiatedButFailed",
          name: "Past 30 Days Initiated but Failed",
        },
        {
          // id: "repayment_past45processed", name: "Past 45 Days Processed"
          id: "repayment_past30processed",
          // name: "Past 30 Days Processed",
          name: "Past 7 Days Processed",
        },
        { id: "repayment_delayedFails", name: "Past 12 Months Delayed Fails" },
        {
          id: "repayment_delayedCanceled",
          name: "Past 12 Months Delayed Canceled",
        },
        {
          id: "repayment_prepareForProcessing",
          name: "In Process", //action will link to loan detail page to skip, postone, modify
        },
        {
          id: "repayment_today",
          // name: "Today", //can cancel or modify before 3:45pm ET
          name: "Scheduled Today *",
        },
        {
          // id: "repayment_next15daysScheduled", name: "Next 15 Days Scheduled"
          id: "repayment_next15daysScheduled",
          name: "Next 10 Days Planned",
        },
      ],
    },
    {
      id: "disbursement",
      name: "Disbursements",
      items: [
        {
          // id: "disbursement_past45failed", name: "Past 45 Days Failed"
          id: "disbursement_past30failed",
          name: "Past 30 Days Failed",
        },
        {
          // id: "disbursement_past45processedAndProcessing",
          // name: "Past 45 Days Processed",
          id: "disbursement_past30processedAndProcessing",
          name: "Past 30 Days Processed",
        },
        {
          id: "disbursement_delayed_fails",
          name: "Past 12 Months Delayed Fails",
        },
        {
          id: "disbursement_prepareForProcessing",
          name: "In Process",
        },
        {
          id: "disbursement_today",
          // name: "Today", //can cancel or modify before 3:45pm ET
          name: "Scheduled Today *",
        },
        {
          // id: "disbursement_next15daysScheduled",
          // name: "Next 15 Days Scheduled",
          id: "disbursement_next10daysScheduled",
          name: "Next 10 Days Planned",
        },
      ],
    },
    {
      id: "refund",
      name: "Refunds",
      items: [
        {
          id: "refund_past180failed",
          name: "Past 180 Days Failed",
        },
        {
          id: "refund_past180processed",
          name: "Past 180 Days Processed",
        },

        {
          id: "refund_prepareForProcessing",
          name: "In Process",
        },
        {
          id: "refund_today",
          name: "Scheduled Today *",
        },
      ],
    },
    //move Refill to Admin menus
    // {
    //   //Refill
    //   id: "refill",
    //   name: "Refills",
    //   items: [
    //     {
    //       id: "refill_past180processed",
    //       name: "Past 180 Days Processed",
    //     },
    //     {
    //       id: "refill_prepareForProcessing",
    //       name: "In Process",
    //     },
    //     {
    //       id: "refill_today",
    //       name: "Scheduled Today *",
    //     },
    //   ],
    // },
  ];
  return (
    <>
      <HmSubHeaderTitle
        title={headerTitle}
        sx={{
          display: "block",
          position: "absolute",
          top: "70px",
          left: "75px",
        }}
      />
      {headerSubTitle && (
        <Typography
          sx={{
            display: "block",
            position: "absolute",
            top: "115px",
            left: "75px",
            fontSize: "14px",
            color: "red",
          }}
        >
          {headerSubTitle}
        </Typography>
      )}

      <Card className="hm-list-aside">
        <CardContent sx={{ pt: 1, height: "100%" }}>
          <MenuList sx={{ mt: 0, pt: 0 }} id="list-ach-processing-menus">
            {loanMenus.map((menu) => (
              <div key={menu.id} id={`list-ach-processing-${menu.name}-menu`}>
                {menu.name == "Disbursements" && <hr />}
                {menu.name == "Refills" && <hr />}
                {menu.name == "Refunds" && <hr />}
                <Typography
                  variant="h3"
                  sx={{
                    pl: 0,
                    pt: 1,
                    mt: 2,
                    pb: 1,
                    fontWeight: "bold",
                    mb: 1,
                    color: "#000",
                  }}
                >
                  {menu.name}
                </Typography>
                {menu.items.map((subMenu) => (
                  <>
                    {subMenu.id == "disbursement_prepareForProcessing" && (
                      <hr className="thinner" />
                    )}
                    {subMenu.id == "repayment_prepareForProcessing" && (
                      <hr className="thinner" />
                    )}
                    <CustomMenuItemLink
                      key={subMenu.id}
                      to={`/${
                        // subMenu.id.includes("repayment")
                        //   ? "repayment"
                        //   : "disbursement"
                        //加上refund and refill
                        subMenu.id.includes("repayment")
                          ? "repayment"
                          : subMenu.id.includes("disbursement")
                          ? "disbursement"
                          : subMenu.id.includes("refund")
                          ? "refund"
                          : "refill"
                      }?filter={"status":"${subMenu.id}"} `}
                      onClick={() => {
                        props.onChange(subMenu.id);
                      }}
                      state={{ _scrollToTop: true }}
                      primaryText={
                        <AppMenuTitle
                          type={formatTitleText(subMenu.name)}
                          count={totalData ? totalData[subMenu.id] || 0 : 0}
                        />
                      }
                      selected={selected === subMenu.id}
                      tooltipProps={{
                        // title: formatTitleText(subMenu.name),
                        title: subMenu.name,
                        children: <></>,
                      }}
                    />
                  </>
                ))}
              </div>
            ))}

            <hr />
          </MenuList>
          <Link
            to={`/reports?filter={"status":"Inception to Date","reportType":"achpayments"}`}
            sx={{
              "&.RaLink-link": {
                color: "#1976d2",
                textDecoration: "none",
              },
              "& .MuiLink-root": {
                color: "#1976d2",
                textDecoration: "none",
              },
              "&:hover": {
                textDecoration: "underline",
              },
              paddingBottom: "20px",
            }}
          >
            Download More ACH Transfers Data
          </Link>
        </CardContent>
      </Card>
    </>
  );
};

export default AchPaymentsAside;
